export const DIRECTIONS = {
  prev: 'prev',
  next: 'next'
};

export const EFFECT_3D_NAMES = {
  daw: 'daw',
  scale: 'scale'
};